import { useImmer } from "use-immer";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons/faTrashCan";

const Component = ({ config, onChange }) => {
  const scoreTemplate = {
    similarityMin: 0,
    similarityMax: 0,
    score: 0,
  };
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  const addScore = () => {
    updateData((draft) => {
      draft.scores.push(structuredClone(scoreTemplate));
    });
  };

  const removeScore = (index) => {
    updateData((draft) => {
      draft.scores.splice(index, 1);
    });
  };

  return (
    <>
      <table className="config-table">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>History lookup [minutes]</td>
            <td>
              <input
                type="number"
                value={data.historyLookupMinutes}
                onChange={(e) =>
                  updateData((d) => {
                    d.historyLookupMinutes = e.target.value;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Odometer length min.</td>
            <td>
              <input
                type="number"
                value={data.odometerLengthMin}
                onChange={(e) =>
                  updateData((d) => {
                    d.odometerLengthMin = e.target.value;
                  })
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
      <table className="config-table-double table-with-button">
        <thead>
          <tr>
            <th>Similarity min.</th>
            <th>Similarity max</th>
            <th>Score</th>
            <th>
              <FontAwesomeIcon
                icon={faPlus}
                className="icon-clickable"
                onClick={addScore}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.scores.map((score, index) => (
            <tr key={index}>
              <td>
                <input
                  type="number"
                  min={0}
                  max={1}
                  step={0.5}
                  value={score.similarityMin}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].similarityMin = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <input
                  type="number"
                  min={0}
                  max={1}
                  step={0.5}
                  value={score.similarityMax}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].similarityMax = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <input
                  type="number"
                  min={0}
                  max={1}
                  step={0.5}
                  value={score.score}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].score = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <FontAwesomeIcon
                  icon={faTrashCan}
                  className="icon-clickable"
                  onClick={() => removeScore(index)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default Component;
